import React from 'react';
import { 
    Shield, Divide, MapPin, Users, BookOpen, Mic, Camera, 
    FirstAid, Utensils, Radio, Book, Activity, Award,
    Wifi, AlertCircle, Heart,Bus,User,Clock,Smartphone
} from 'react-feather';
import "../../Component/Campus.css"

const Campus = () => {
  return (
    <>
      <section className="Subpage_Hero bg-gradient-primary">
        <div className="container py-5">
          <div className="text-start text-white" data-aos="fade-up">
            <h1 className="display-4 fw-bold">Campus Life</h1>
            <p className="lead">
              A vibrant ecosystem fostering holistic development and safety
            </p>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          {/* Safety & Security Section */}
          <div className="row mb-5 align-items-center">
            
            <div className="col-lg-6">
              <div className="ps-lg-4 card p-3 border-danger-subtle">
                <div className="d-flex align-items-center mb-3">
                  <div className="icon-box-sm bg-danger text-white rounded-2 p-2 me-4">
                    <Shield size={22} />
                  </div>
                  <h2 className="h3 color fw-bold  mb-0">Campus Safety & Security</h2>
                </div>
                <div className="row">
                  {[
                    {icon: <Camera size={20} />, title: "CCTV-Monitored Classrooms", desc: "24/7 surveillance in all learning areas"},
                    {icon: <AlertCircle size={20} />, title: "Emergency Response Drills", desc: "Regular safety training for all"},
                    {icon: <Wifi size={20} />, title: "Cyber Safety Awareness", desc: "Digital citizenship programs"},
                    {icon: <Camera size={20} />, title: "First Aid & Medical Care", desc: "Fully equipped medical room"}
                  ].map((item, index) => (
                    <div key={index} className="col-md-6 mb-3">
                      <div className="card h-100 border-0 shadow-sm hover-lift">
                        <div className="card-body">
                          <div className="d-flex">
                            <div className="icon-box-sm bg-light-danger text-danger rounded-2 p-2 me-3">
                              {item.icon}
                            </div>
                            <div>
                              <h5 className="h5 fw-bold mb-1">{item.title}</h5>
                              <p className="text-muted mb-0">{item.desc}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="card border-0 shadow-lg rounded-3 overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1588072432836-e10032774350?ixlib=rb-4.0.3&auto=format&fit=crop&w=1472&q=80" 
                  alt="Campus security" 
                  className="img-fluid"
                />
              </div>
            </div>
          </div>

          {/* Transport Section */}
<div className="row mb-5 align-items-center">
  <div className="col-lg-6 position-relative mb-4 mb-lg-0">
    <div className="position-relative">
      <img 
        src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957" 
        alt="School transport" 
        className="img-fluid rounded-3 shadow-lg"
        style={{ transform: 'rotate(-0deg)' }}
      />
      {/* Decorative Bus Elements */}
      <div className="position-absolute top-0 start-0 w-100 h-100">
        <div className="position-absolute top-50 start-0 translate-middle-y" style={{transform: 'translate(-30px, -30px)' }}>
          <div className="bg-primary text-white rounded-circle p-2 d-flex align-items-center justify-content-center shadow"
               style={{ width: '60px', height: '60px' }}>
            <MapPin size={28} />
          </div>
        </div>
        <div className="position-absolute bottom-0 end-0" style={{ transform: 'translate(30px, 30px)' }}>
          <div className="bg-danger text-white rounded-pill px-3 py-2 d-flex align-items-center shadow-sm">
            <span className="fw-bold me-2">GPS</span>
            <Wifi size={18} />
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div className="col-lg-6">
    <div className="ps-lg-4 card p-3 ">
      {/* Section Header with Road-inspired Design */}
      <div className="position-relative mb-4">
        <div className="d-flex align-items-center">
          <div className="icon-box-sm bg-warning text-white rounded-2 p-2 mt-3 me-4 ">
            <AlertCircle size={22} />
          </div>
          <h2 className="mb-0 position-relative z-1">
            <span className="h3 color fw-bold pe-3">Safe Transport</span>
          </h2>
        </div>
        <div className="position-absolute top-50 start-0 w-100 h-2 bg-light" 
             style={{ zIndex: 0, transform: 'translateY(-50%)' }}>
          <div className="w-25 h-100 bg-warning"></div>
        </div>
      </div>

      {/* Feature Cards Designed as Bus Stops */}
      <div className="row g-3">
        {[
          {
            icon: <User size={20} />,
            title: "Trained Attendants",
            desc: "Certified staff on every route"
          },
          {
            icon: <Clock size={20} />,
            title: "Punctual Service",
            desc: "On-time pickups and drop-offs"
          },
          {
            icon: <Shield size={20} />,
            title: "Safety Protocols",
            desc: "Regular vehicle inspections"
          },
          {
            icon: <Smartphone size={20} />,
            title: "Live Tracking",
            desc: "Real-time parent notifications"
          }
        ].map((item, index) => (
          <div key={index} className="col-md-6">
            <div className="card border-0 shadow-sm h-100 hover-lift" 
                 style={{ borderLeft: '4px solid #ffc107' }}>
              <div className="card-body p-3">
                <div className="d-flex align-items-center">
                  <div className="icon-box-sm bg-light-warning text-warning rounded-2 p-2 me-3">
                    {item.icon}
                  </div>
                  <div>
                    <h5 className="h5 fw-bold  mb-1">{item.title}</h5>
                    <p className="text-muted mb-0 small">{item.desc}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Route Map Visual */}
      <div className="mt-4 pt-3 position-relative">
        <div className="position-absolute top-0 start-0 h-100 w-4 bg-warning rounded-pill"></div>
        <div className="ps-5">
          <p className="mb-0 small text-muted">
            <span className="fw-bold text-dark">Our Routes:</span> Covering all major neighborhoods with 
            <span className="text-info fw-bold"> 25+ pickup points</span> across the city
          </p>
        </div> 
      </div>
    </div>
  </div>
</div>

          {/* Co-Scholastic Activities */}
          <div className="mb-5 p-4 mt-3">
            <div className="text-center mb-4">
               
                <h2 className="h2 fw-bold display-5 mb-1">Co-Scholastic Opportunities</h2>
            </div>

            <div className="position-relative">
                <div className="overflow-hidden">
                <div className="animate-slide d-flex" style={{ width: 'max-content' }}>
                {[...Array(3)].map((_, loopIdx) => (
                <React.Fragment key={loopIdx}>
            {[
              {icon: <Award size={20} />, title: "STEM Club", desc: "Robotics, coding & innovation"},
              {icon: <BookOpen size={20} />, title: "Literature Club", desc: "Debate, writing & reading"},
              {icon: <Heart size={20} />, title: "Arts & Drama", desc: "Visual & performing arts"},
              {icon: <Users size={20} />, title: "Student Parliament", desc: "Leadership development"},
              {icon: <Mic size={20} />, title: "School Radio", desc: "Student-run broadcasting"},
              {icon: <Book size={20} />, title: "School Magazine", desc: "Annual student publication"}
            ].map((item, index) => (
              <div
                key={`${loopIdx}-${index}`}
                className="mx-2"
                style={{ width: '280px', flexShrink: 0 }}
              >
                <div className="card border-0 daily-structure shadow-none mb-4 hover-lift" style={{ height: '180px' }}>
                  <div className="card-body text-center p-3 d-flex flex-column justify-content-between">
                    <div>
                      <div className="icon-box-md bg-light-success text-success rounded-3 p-2 mb-2 mx-auto"
                          style={{ width: '50px', height: '50px' }}>
                        {item.icon}
                      </div>
                      <h4 style={{ fontSize: '1.1rem', marginBottom: '0.5rem', color: '#333' }}>
                        {item.title}
                      </h4>
                    </div>
                    <p className="text-muted mb-0" 
                      style={{
                        fontSize: '0.85rem',
                        lineHeight: '1.4',
                        borderTop: '1px solid #eee',
                        paddingTop: '0.5rem',
                        marginTop: '0.5rem'
                      }}>
                      {item.desc}
                    </p>
                  </div>
                        </div>
                    </div>
                    ))}
                </React.Fragment>
                ))}
            </div>
            </div>
        </div>
        </div>

          {/* Sports & Wellness */}
          <div className="row mb-5 g-4">
            <div className="col-md-6">
              <div className="card border-0 ">
                <div className="card-header  text-center bg-white  py-3">
                  <h3 className="mb-0 h4 fw-bold ">
                    Annual Sports & Events
                  </h3>
                </div>
                <div className="card-body">
                  <div className="row g-3">
                    {[1,2,3].map((item) => (
                      <div key={item} className="col-md-4">
                        <div className="ratio ratio-1x1 rounded-3 overflow-hidden">
                          <img
                            src={`assets/images/item${1,item}.jpg`}
                            alt={`Sports ${item}`}
                            className="object-contain rounded-top"
                            />
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-3">
                    <div className="d-flex align-items-center  mb-2">

                        <h5 className="fw-bold  color ">Highlights:</h5>
                    </div>

                    <div className="row g-3">
                        {[
                        {
                            title: "Sports Extravaganza",
                            description: "Annual Sports Day with 50+ events",
                            icon: "🏆",
                            color: "primary"
                        },
                        {
                            title: "Competitive Spirit",
                            description: "Inter-school championship tournaments",
                            icon: "🤼",
                            color: "success"
                        },
                        {
                            title: "Friendly Rivalries",
                            description: "Inter-house competitions ,logical Thinking",
                            icon: "🆚",
                            color: "warning"
                        },
                        {
                            title: "Mind & Body",
                            description: "Yoga & wellness programs  Healthy eating habits",
                            icon: "🧘",
                            color: "info"
                        }
                        ].map((event, index) => (
                        <div key={index} className="col-sm-6">
                            <div className="card border-0 shadow-sm h-100 hover-lift transition-all">
                            <div className="card-body p-3 d-flex align-items-start">
                            <span className="display-5 me-3">{event.icon}</span>
                            <div>
                                <h6 className="h6 mb-1 fw-bold">{event.title}</h6>
                                <p className="text-muted small mb-0">{event.description}</p>
                            </div>
                            </div>
                        </div>
                        </div>
                        ))}
                    </div>
                    </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card border-0  h-100">
                <div className="card-header bg-white  py-3" style={{borderRadius:"16px"}}>
                  <h3 className="mb-0 h4 fw-bold text-center">
                    {/* <Heart className="me-3" size={24} /> */}
                    Well-being Initiatives
                  </h3>
                </div>
                <div className="card-body">
                  <div className="row g-3 mb-4">
                    {[1,2,3].map((item) => (
                      <div key={item} className="col-md-4">
                        <div className="ratio ratio-1x1 rounded-3 overflow-hidden">
                          <img 
                            src={`assets/images/init${1,item}.jpg`}
                            alt={`Wellness ${item}`}
                            className="object-cover"
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mt-4">
                    <h5 className="fw-bold mb-3 color">Our Wellness Programs:</h5>
                    <div className="row g-3">
                      {[
                        { 
                          icon: '🧘', 
                          title: "Daily Yoga Sessions", 
                          desc: "Mindful movement for all ages"
                        },
                        { 
                          icon: '🧠', 
                          title: "Mental Health Workshops", 
                          desc: "Building emotional resilience"
                        },
                        { 
                          icon: '🍎', 
                          title: "Nutrition Awareness", 
                          desc: "Healthy eating habits"
                        },
                        { 
                          icon: '👦', 
                          title: "Age-Specific Zones", 
                          desc: "Tailored activities by age group"
                        }
                      ].map((program, index) => (
                        <div key={index} className="col-sm-6">
                          <div className="card border-0 shadow-sm h-100 hover-lift transition-all">
                            <div className="card-body p-3 d-flex align-items-start">
                              <span className="display-5 me-3">{program.icon}</span>
                              <div>
                                <h6 className="h6 mb-1 fw-bold">{program.title}</h6>
                                <p className="text-muted small mb-0">{program.desc}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Facilities Gallery */}
          <div className="mb-4">
            <div className=" mb-4">
              <h2 className="h2 fw-bold text-center  display-5 mb-0">Campus Facilities</h2>
            </div>
            <div className="row g-4 p-4">
              {[
                {title: "Clean Cafeteria", img: "cafe.jpg"},
                {title: "Science Labs", img: "science.jpg"},
                {title: "Library", img: "library.jpg"},
                {title: "Auditorium", img: "auditorium.jpg"},
                {title: "Sports Complex", img: "sports-complex.jpg"},
                {title: "Art Studio", img: "art-studio.jpg"}
              ].map((item, index) => (
                <div key={index} className="col-md-4 col-6">
                  <div className="card border-0 shadow-sm h-100 hover-lift">
                    <div className="ratio ratio-16x9">
                      <img 
                        src={`assets/images/${item.img}`}
                        alt={item.title}
                        className="object-cover"
                      />
                    </div>
                    <div className="card-body text-center">
                      <h5 className="mb-0">{item.title}</h5>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Campus;